import { IOverviewStore } from './index'

export default {
  error: false,
  dateTo: undefined,
  dateFrom: undefined,
  selectedIndex: 1,
  differencePeriod: undefined,
  selectedRooms: [],
  stats: {
    diffStats: undefined,
    ocupancy: 0,
    income: {
      total: 0,
      additional: 0,
      recived: 0,
      awaits: 0,
    },
    events: [],
    eventsCancelled: [],
    avgDays: 0,
    bookingWindow: 0,
    ADR: 0,
    RevPAR: 0,
  },
} as IOverviewStore
